/**
 * 营收数据
 */

import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import intl from 'react-intl-universal';

import { Calculator, parseFen2Currency } from '@/utils/number';
import { createMapRender, BillIncomeInfo } from '@/pages/handover/helper';
import { PROJECT_ITEM_MAP, BILL_PROJECT_REMARK_MAP } from '@/pages/handover/BaseBusiness';

import styles from './index.module.scss';

interface IProps {
  dataSource: BillIncomeInfo[];
  type: keyof typeof BILL_PROJECT_REMARK_MAP;
}

const Index: React.FC<IProps> = (props) => {
  const dataSource = props.dataSource || [];
  const remarkMap = BILL_PROJECT_REMARK_MAP[props.type] || {};

  const columns: ColumnsType<BillIncomeInfo> = [
    {
      title: intl.get('handover_table_column_project'),
      dataIndex: 'projectCode',
      className: 'table-content-nowrap',
      render: createMapRender(PROJECT_ITEM_MAP),
    },
    {
      title: intl.get('handover_bill_income_column_income'),
      dataIndex: 'income',
      className: 'table-content-nowrap',
      render: (val) => parseFen2Currency(val),
    },
    {
      title: intl.get('handover_table_column_remark'),
      dataIndex: 'projectCode',
      render: createMapRender(remarkMap, ''),
    },
  ];

  const renderSummary = () => {
    const incomeVal = new Calculator(0);
    dataSource.forEach((item) => {
      incomeVal.plus(item.income || 0);
    });

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={1}>
          <div className="handover-table-summary-title">
            {intl.get('handover_table_summary_total')}
          </div>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2}>{parseFen2Currency(incomeVal.getValue())}</Table.Summary.Cell>
        <Table.Summary.Cell index={3} />
      </Table.Summary.Row>
    );
  };

  return (
    <div className={styles.billIncomeTable}>
      <div className="groupLabel">{intl.get('handover_bill_income_block_title')}</div>
      <Table
        rowKey="projectCode"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        summary={renderSummary}
      />
    </div>
  );
};

export default Index;
